import { useLocation } from "react-router-dom";
import { IconButton } from "../ui";
import { useNextT } from "../i18n";
import { useCanSeeNotifications } from "./useCanSeeNotifications";
import { useOpenInbox } from "../approvals/openInbox";
import { useBellCount } from "../approvals/bell";
import { Icon } from "./icons";
import { TOP_SLOT_ID } from "./topSlot";
import { matchNav } from "./nav";
import { useNav } from "./useNav";
import s from "./TopBar.module.scss";

const EXTRA: Record<string, string> = { "/settings": "shell.account.settings" };

/** The slim bar on phones and tablets only (layout F; desktop has no bar): menu button, page name, bell. */
export const TopBar = ({ onOpenMenu }: { onOpenMenu(): void }) => {
  const { t } = useNextT();
  const { pathname } = useLocation();
  const { main, admin } = useNav();
  // The new notifications panel (2D F9), never today's; its number from the new counts only.
  const openInbox = useOpenInbox();
  const canSeeNotifications = useCanSeeNotifications() && !!openInbox;
  const count = useBellCount(canSeeNotifications);
  const here = matchNav(main, pathname) ?? matchNav(admin, pathname);
  const onHelp = /^\/(next\/)?help(\/|$)/.test(pathname);
  const crumb = here ? t(`shell.nav.${here.label ?? here.key}`) : EXTRA[pathname] ? t(EXTRA[pathname]) : onHelp ? t("shell.nav.help") : "";

  return (
    <header className={s.bar}>
      <IconButton label={t("shell.top.open_menu")} icon={<Icon name="menu" />} onClick={onOpenMenu} />
      <nav className={s.crumbs} aria-label={t("shell.top.breadcrumb")}>
        {crumb && <span aria-current="page">{crumb}</span>}
      </nav>
      <span id={TOP_SLOT_ID} className={s.slot} />
      {canSeeNotifications && (
        <span className={s.bellWrap}>
          <IconButton label={t("shell.top.notifications_count", { count })} icon={<Icon name="bell" />} onClick={() => openInbox?.()} />
          {count > 0 && <span className={s.badge} aria-hidden="true">{count > 99 ? "99+" : count}</span>}
        </span>
      )}
    </header>
  );
};
